var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgorandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59659 11.3607L1.58913 11.3665C1.4847 11.4484 1.34848 11.5 1.15083 11.5C0.904149 11.5 0.753524 11.4345 0.65095 11.3431C0.556603 11.259 0.5 11.1498 0.5 10.9636C0.5 10.8945 0.51306 10.8003 0.550599 10.6768C0.588476 10.5596 0.657 10.3978 0.764305 10.186L0.765715 10.1833L0.775191 10.165L0.812152 10.0935L0.952466 9.82196L1.45347 8.85251L2.9754 5.90776C3.52939 4.83595 4.08413 3.7628 4.5019 2.95489L5.00856 1.97535C5.06544 1.86545 5.10977 1.77987 5.14126 1.71908C5.18059 1.64317 5.19987 1.60594 5.19854 1.60831C5.23414 1.54487 5.2726 1.46238 5.3121 1.37159C5.67957 0.669971 6.01537 0.5 6.26838 0.5C6.52565 0.5 6.87798 0.682435 7.26864 1.44006L7.2842 1.47023L7.3037 1.49803L7.34625 1.55869L11.8594 10.1885C12.0043 10.4757 12.0794 10.6544 12.1062 10.7453L12.11 10.7581L12.1144 10.7707C12.152 10.8767 12.1592 10.9378 12.1592 10.9636C12.1592 11.1498 12.1026 11.259 12.0082 11.3431L12.3391 11.7144L12.0082 11.3431C11.9057 11.4345 11.755 11.5 11.5083 11.5C11.3165 11.5 11.1672 11.4479 11.0393 11.3508L11.0381 11.3499C10.9117 11.2546 10.7445 11.0563 10.5506 10.7014L10.5502 10.7004L10.5226 10.6364C10.4985 10.5805 10.463 10.4986 10.4177 10.3945C10.3271 10.1863 10.1971 9.88902 10.0393 9.53234C9.72397 8.81928 9.29706 7.86753 8.85181 6.91495C8.40745 5.96428 7.94123 5.005 7.54783 4.28023C7.35219 3.9198 7.16766 3.60447 7.00808 3.37437C6.92954 3.26113 6.84578 3.15198 6.76008 3.06586C6.7174 3.02297 6.66191 2.97316 6.59491 2.93124C6.53353 2.89283 6.41892 2.83333 6.26838 2.83333C6.11736 2.83333 6.00248 2.89316 5.94057 2.93221C5.87333 2.97464 5.8179 3.02498 5.77548 3.06818C5.69031 3.1549 5.60759 3.26458 5.5304 3.37799C5.37351 3.60849 5.19288 3.92415 5.00186 4.28464C4.6177 5.00964 4.16378 5.96908 3.73169 6.91978C3.29871 7.87243 2.88406 8.82422 2.57788 9.53731C2.42472 9.894 2.29856 10.1913 2.21065 10.3995C2.16669 10.5037 2.13228 10.5855 2.10883 10.6414L2.08206 10.7054L2.082 10.7055C1.88772 11.0677 1.72084 11.2671 1.59664 11.3608L1.59659 11.3607Z",
    fill: "url(#paint0_linear_0_1)",
    stroke: "url(#paint1_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55602 10.4347C7.55602 10.9781 7.05421 11.4999 6.32977 11.4999C5.60533 11.4999 5.10352 10.9781 5.10352 10.4347C5.10352 9.89137 5.60533 9.36951 6.32977 9.36951C7.05421 9.36951 7.55602 9.89137 7.55602 10.4347Z",
    fill: "url(#paint2_linear_0_1)",
    stroke: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -0.421971,
    y1: 0.626666,
    x2: 11.0333,
    y2: 12.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: -0.421971,
    y1: 0.626666,
    x2: 11.0333,
    y2: 12.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 4.78381,
    y1: 12.1043,
    x2: 7.73425,
    y2: 8.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 4.78381,
    y1: 12.1043,
    x2: 7.73425,
    y2: 8.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorandIcon);
export default __webpack_public_path__ + "static/media/AlgorandIcon.9432cbcf.svg";
export { ForwardRef as ReactComponent };